import * as React from "react"
import Navbar from "../navbar/Navbar"
import "./layout.style.scss";

const Layout = ({ children }: any) => {

    return (
        <>
            <Navbar />
            <main>{children}</main>
        </>
    )
}

export default Layout